const razorpayKeys = {
    admin: {
        prod: 'rzp_live_3FRhmwoEN5dMLX',
        test: 'rzp_test_Nkm3dFECV8Sbax'
    },
    cont: {
        prod: 'rzp_live_OiofipMfrWYSEq',
        test: 'rzp_test_KzqOSqq2P1bLhO'
    }
}

export function getRazorpayKey(origin, paymentType) {
    return razorpayKeys[paymentType][origin.includes('tangentindia.org') ? 'prod' : 'test'];
}